<script setup lang="ts">
import { computed, withDefaults } from 'vue'

interface PropTypes {
  ariaLabel?: string
  value: string
  index: string
}

const props = withDefaults(defineProps<PropTypes>(), {
  ariaLabel: 'Tab Content',
  value: undefined,
  index: null,
})

const isShowing = computed(() => props.value === props.index)
</script>

<template>
  <div v-if="isShowing" role="tabpanel" :aria-labelledby="ariaLabel" class="h-full w-full">
    <slot />
  </div>
</template>
